/** Paths mock payloads until B3 /paths ships. */

export const PATHS_MOCK = {
  dataSourceLabel: 'VM Platform · CMP · POS',
  confidence: {
    tone: 'warning',
    title: 'Mixed confidence — 2,100 pending held out. Scan/POS links are directional.',
  },
  listMeta: {
    title: 'Top paths',
  },
  paths: [
    {
      id: 'ticket_scan',
      stages: ['Ticket', 'Scan'],
      share: 0.468,
      count: 4820,
      badge: null,
      barTone: 'primary',
      insight: 'Largest group: attends, then leaves without spending.',
      action: 'Add mobile POS near North Stand exits on weekdays.',
    },
    {
      id: 'ticket_scan_pos',
      stages: ['Ticket', 'Scan', 'POS'],
      share: 0.301,
      count: 3100,
      badge: null,
      barTone: 'primary',
      insight: 'Attends and spends on matchday — ~3 in 10 buyers.',
      action: 'Open merch gates earlier; track attach vs open time.',
    },
    {
      id: 'ticket_only',
      stages: ['Ticket'],
      share: 0.136,
      count: 1400,
      badge: 'incomplete',
      barTone: 'incomplete',
      insight: 'Never scanned in on played fixtures.',
      action: 'Morning-of reminder push for the next midweek home game.',
    },
    {
      id: 'ticket_season',
      stages: ['Ticket', 'Season card'],
      share: 0.072,
      count: 742,
      badge: 'high_confidence',
      barTone: 'success',
      insight: 'High-confidence CMP path — mostly online checkouts.',
      action: 'Keep season-card offer on the confirmation page.',
    },
    {
      id: 'ticket_addon',
      stages: ['Ticket', 'Add-on'],
      share: 0.054,
      count: 556,
      badge: 'high_confidence',
      barTone: 'success',
      insight: 'Ticket-linked add-ons without a recorded scan.',
      action: 'Push jersey/discount bundles at online checkout.',
    },
    {
      id: 'ticket_scan_pos_addon',
      stages: ['Ticket', 'Scan', 'POS', 'Add-on'],
      share: 0.031,
      count: 319,
      badge: 'high_confidence',
      barTone: 'success',
      insight: 'Full commercial path — small but high value.',
      action: 'Study this segment for VIP / early-entry offers.',
    },
  ],
  distribution: [
    { id: 'scan', label: 'Reach scan', value: 0.864 },
    { id: 'pos', label: 'Spend at POS', value: 0.348 },
    { id: 'season', label: 'Season card', value: 0.124 },
    { id: 'addon', label: 'Ticket add-on', value: 0.181 },
  ],
  incomplete: {
    title: 'Most incomplete',
    headline: 'Ticket only — 1,400 (13.6%) never scanned',
    action: 'Reminder push morning of next midweek fixture.',
  },
};
